import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["optionResolver"];
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import BusinessUnitDropdownReferenceResolver from 'reference-resolvers/resolvers/BusinessUnitDropdownReferenceResolver';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isError, isLoading } from 'reference-resolvers/utils';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { BUSINESS_UNIT_DROPDOWN_OPTION } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { sortBusinessUnitsByName } from './String';
import { jsx as _jsx } from "react/jsx-runtime";
const mapReferenceResolverToPlainJS = resolverInstance => {
  if (isError(resolverInstance) || isLoading(resolverInstance)) {
    return [];
  }
  return resolverInstance.toJS().map(item => item.referencedObject).sort(sortBusinessUnitsByName);
};
const WithBusinessUnitsDataFetching = Component => {
  const DataProvider = _ref => {
    let {
        optionResolver
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const formattedOptions = mapReferenceResolverToPlainJS(optionResolver);
    return /*#__PURE__*/_jsx(Component, Object.assign({
      buOptions: formattedOptions,
      isLoading: isLoading(optionResolver),
      hasFailed: isError(optionResolver)
    }, props));
  };
  const mapResolversToProps = resolvers => {
    return {
      optionResolver: resolvers[BUSINESS_UNIT_DROPDOWN_OPTION].all()
    };
  };
  return ProvideReferenceResolvers({
    [BUSINESS_UNIT_DROPDOWN_OPTION]: BusinessUnitDropdownReferenceResolver
  }, ResolveReferences(mapResolversToProps)(DataProvider));
};
export default WithBusinessUnitsDataFetching;